var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineselecticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08568 10.3887L1.08557 10.3888C0.710631 10.7639 0.5 11.2725 0.5 11.8028C0.5 12.3331 0.710631 12.8417 1.08557 13.2168L1.08563 13.2169L7.09641 19.2276C8.07272 20.204 9.65564 20.204 10.6319 19.2276L21.9452 7.91436L21.9454 7.91423C22.131 7.72842 22.2783 7.50786 22.3787 7.26513C22.4792 7.02241 22.5308 6.76228 22.5307 6.49959C22.5306 6.23692 22.4788 5.97682 22.3782 5.73417C22.2776 5.49152 22.1302 5.27106 21.9444 5.08537C21.7585 4.8997 21.538 4.75243 21.2953 4.65199C21.0525 4.55156 20.7924 4.49991 20.5297 4.5C20.267 4.50009 20.0069 4.55192 19.7643 4.65253C19.5217 4.75313 19.3013 4.90051 19.1156 5.08628C19.1156 5.08631 19.1155 5.08634 19.1155 5.08638L8.86415 15.3392L3.91373 10.3888L3.91368 10.3887C3.53862 10.0138 3.03001 9.80312 2.49968 9.80312C1.96935 9.80312 1.46073 10.0138 1.08568 10.3887Z",
    fill: "currentColor",
    stroke: "#0087C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineselecticon);
export default __webpack_public_path__ + "static/media/outlineselect.icon.17e0bcd5fcef2432107ff054859567cf.svg";
export { ForwardRef as ReactComponent };